var _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.75V5.25C8.25 4.83579 8.58579 4.5 9 4.5H21C21.4142 4.5 21.75 4.83579 21.75 5.25V12.75C21.75 13.1642 21.4142 13.5 21 13.5H15",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.5C18.2042 7.5 16.2958 7.5 13.5 7.5",
    stroke: "current",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 7.5,
    r: 0.75,
    transform: "rotate(-180 11.25 7.5)",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 19.5L5.04641 19.5C7.49922 19.5 9.77217 18.2131 11.0341 16.1098V16.1098C11.176 15.8733 11.3719 15.6738 11.6058 15.5276L15.9597 12.8064C16.6661 12.3649 16.8681 11.4271 16.406 10.734V10.734C16.0225 10.1588 15.2915 9.92636 14.6462 10.1745L6 13.5",
    stroke: "current",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33615 6.75C5.45889 6.75 4.60939 7.05756 3.93546 7.61917L1.5 9.64872V11.6013L4.89573 8.7715C5.30009 8.43454 5.80979 8.25 6.33615 8.25H7.5V6.75H6.33615Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment24);
export default __webpack_public_path__ + "static/media/Payment-24.4e3694f3.svg";
export { ForwardRef as ReactComponent };